import makeApiService from "./api-service";
import { isDev } from "@/utils";

let apiUrl = "https://api.willowlife.uk/api/v1", apiOrigin = "https://admin.willowlife.uk";

const apiService = makeApiService(apiUrl);
apiService.setHeader("X-Api-Origin", apiOrigin);
if(isDev) {
    apiService.setHeader("X-Dev-Mode", 1);
}

export default apiService;
